import React from 'react'
import Svg from './Svg'
export const SvgHome = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M23.853 14.188l-4.425-5.291V.96h-2.949v4.41L12.054.079.256 14.188v.883h2.95v8.818h7.374v-5.292h2.949v5.292h7.374v-8.818h2.95z" />
  </Svg>
))
SvgHome.isIcon = true
export default SvgHome
